import React from "react";
import {ActionRow, ActionRowButton, ActionRowMoreButton, Icon} from "peggirkit";
import {PlusIcon, TrashIcon} from "@heroicons/react/24/outline";
import {FormattedMessage} from "react-intl";
import router from "@/routing/Router";
import {SetStateFn} from "@/utils/SetStateUtils";


type Props = {
    setShowDeleteModal: SetStateFn<boolean>,
};

const EmployeeHeadingActions = ({setShowDeleteModal}: Props) => {
    return (
        <ActionRow
            useMoreButton={true}
            moreButton={
                <ActionRowMoreButton>
                    <FormattedMessage id={"more"}/>
                </ActionRowMoreButton>
            }
            moreButtonPositioning={"end"}
            breakpoints={{
                md: {
                    moreButtonPositioning: "start",
                },
            }}
        >
            <ActionRowButton
                color={"danger"}
                iconBefore={<Icon icon={TrashIcon}/>}
                buttonAction={{
                    as: "button",
                    actionProps: {
                        onClick: () => setShowDeleteModal(true),
                    },
                }}
                showInRowBreakpoint={"xl"}
            >
                <FormattedMessage id={"delete"}/>
            </ActionRowButton>


            <ActionRowButton
                color={"secondary"}
                iconBefore={<Icon icon={PlusIcon}/>}
                buttonAction={{
                    as: "reactRouterLink",
                    actionProps: {to: router.newEmployee.absolutePath()}
                }}
            >
                <FormattedMessage id={"newEmployee"}/>
            </ActionRowButton>
        </ActionRow>
    );
};

export default EmployeeHeadingActions;